import { useEffect, useState } from "react";
import { indicadoresService } from "@/services/indicadores.service";
import { INDICADORES_FALLBACK, type Indicadores } from "@/lib/monto";

const TTL_MS = 12 * 60 * 60 * 1000;
let cache: { value: Indicadores; at: number } | null = null;
let inflight: Promise<Indicadores> | null = null;

async function load(): Promise<Indicadores> {
  if (cache && Date.now() - cache.at < TTL_MS) return cache.value;
  inflight ??= indicadoresService
    .get()
    .then((v) => {
      cache = { value: v, at: Date.now() };
      return v;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

/** UF y UTM del día (caché en memoria 12 h, fallback local si el backend falla). */
export function useIndicadores() {
  const [data, setData] = useState<Indicadores>(() => cache?.value ?? INDICADORES_FALLBACK);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let alive = true;
    load()
      .then((v) => {
        if (alive) setData(v);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return { indicadores: data, loading, esFallback: !data.fecha };
}
